import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Typography from '../components/Typography';
import Button from '../components/Button/Button';
import CheckCircleIcon from '../components/Icons/CheckCircleIcon';

/**
 * Página de éxito para el flujo OAuth de Stripe
 * Se muestra después de conectar exitosamente una cuenta existente de Stripe
 */
const StripeOAuthSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirigir después de 5 segundos
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Container>
      <Card>
        <IconContainer>
          <CheckCircleIcon width={64} height={64} fill="#10B981" />
        </IconContainer>

        <Content>
          <Typography as="h1" $variant="title-2-semibold" style={{ textAlign: 'center' }}>
            ¡Cuenta de Stripe conectada exitosamente!
          </Typography>

          <Typography as="p" $variant="body-1-medium" style={{ textAlign: 'center', color: '#6B7280' }}>
            Su cuenta existente de Stripe ha sido conectada correctamente a su perfil.
            Ya puede comenzar a recibir pagos.
          </Typography>

          <Typography as="p" $variant="body-2-medium" style={{ textAlign: 'center', color: '#9CA3AF' }}>
            Será redirigido automáticamente en unos segundos...
          </Typography>
        </Content>

        <ButtonContainer>
          <Button onClick={handleGoToDashboard} $variant="primary">
            Ir al Dashboard
          </Button>
        </ButtonContainer>
      </Card>
    </Container>
  );
};

export default StripeOAuthSuccess;

// Styled Components
const Container = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.sizing.md};
`;

const Card = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: 0 10px 25px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.lg};
  max-width: 500px;
  padding: ${({ theme }) => theme.sizing.xl};
  width: 100%;
`;

const IconContainer = styled.div`
  align-items: center;
  background: #F0FDF4;
  border-radius: 50%;
  display: flex;
  height: 80px;
  justify-content: center;
  width: 80px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;